export const agenciaValidator = function (agencia) { 
  if (!agencia) return false
  agencia = agencia.replace(/\D/g, '')  
  return /^[0-9]{4,5}$/.test(agencia) 
}